import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { add, divide, multiply, subtract } from 'mathjs';
import { useAuthUser } from 'react-auth-kit';
// import { Bar, Line } from 'react-chartjs-2';
import { useReactToPrint } from 'react-to-print';
import { Printer } from '../printing/printing_component.js';

// import { Chart as ChartJS, LineElement, PointElement, LinearScale, Title } from 'chart.js';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    DataLabels
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// GRAPHQL QUERY
// import { 
//     GetUsersQRCodes,
//     SaveUserQRCode
// } from './users_graphql.js';

// DOCS: https://www.apollographql.com/docs/react/get-started/
// Import everything needed to use the `useQuery` hook

export function BenchmarksGraphComponent(props) {

    const targetRef = useRef(null);

    let Benchmarks = [...props.Benchmarks];
    let Workouts = [...props.Workouts];

    // Sort benchmarks by exercise date to create Labels
    let SortedBenchmarks = Benchmarks.sort(function (a, b) {
        if (a.date_performed < b.date_performed) return -1;
        if (a.date_performed > b.date_performed) return 1;
        return 0;
    });

    const XAxisLabels = SortedBenchmarks.map((W) => dayjs(W.date_performed).format('M-D-YY'));
    const [Arm, setArm] = useState(['L', 'R']);
    const [Exercises, setExercises] = useState(['supra', 'subscap', 'infra', 'teres', 'house']);
    const [GraphData, setGraphData] = useState({
        labels: XAxisLabels,
        datasets: []
    });
    const [GraphGenerated, setGraphGenerated] = useState(false);
    const [GraphOptions, setGraphOptions] = useState({
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: '',
            },
            datalabels: {
                backgroundColor: function (context) {
                    return context.dataset.backgroundColor;
                },
                borderRadius: 4,
                color: 'white',
                font: {
                    weight: 'bold'
                },
                formatter: function (value) {
                    return null;
                    return value.y
                },
                padding: 6
            }
        },
        scales: {
            y: {
                beginAtZero: true, // Start the Y-axis at zero
                max: 20, // Set the maximum value of the Y-axis
                min: 0, // Set the minimum value of the Y-axis
                ticks: {
                    stepSize: 2, // Set the step size of the Y-axis ticks
                },
            },
        }
    });

    console.log("Benchmarks Graph props: ", props)

    useEffect(() => {
        // The code we want to run (on load)
        handleGenerateGraph();

        // Optional return function
        // return () => { };

    }, [Arm, Exercises]);

    if (Benchmarks.length == 0) {
        return;
    }


    // ChartJS.register(LineElement, PointElement, LinearScale, Title);
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend,
        ChartDataLabels,
        // DataLabels
    );

    // Handle generating graph data and options for exercise and arm
    function handleGenerateGraph() {
        // We will have 10 potential datasets - L / R each for 5 exercises
        // let DSupra = SortedBenchmarks.map((SB) => SB[`${Arm}1_weight_${Exercise}`]);
        let DSupra = [];
        let NDSupra = [];
        let DSubscap = [];
        let NDSubscap = [];
        let DInfra = [];
        let NDInfra = [];
        let DTeres = [];
        let NDTeres = [];
        let DHouse = [];
        let NDHouse = [];

        if (Arm.findIndex((A) => A === 'R') > -1) {
            if (Exercises.findIndex((E) => E === 'supra') > -1) DSupra = SortedBenchmarks.map((SB) => { return { y: SB.R_max_supra, arm: 'R', exercise: 'supra' } });
            if (Exercises.findIndex((E) => E === 'subscap') > -1) DSubscap = SortedBenchmarks.map((SB) => { return { y: SB.R_max_subscap, arm: 'R', exercise: 'subscap' } });
            if (Exercises.findIndex((E) => E === 'infra') > -1) DInfra = SortedBenchmarks.map((SB) => { return { y: SB.R_max_infra, arm: 'R', exercise: 'infra' } });
            if (Exercises.findIndex((E) => E === 'teres') > -1) DTeres = SortedBenchmarks.map((SB) => { return { y: SB.R_max_teres, arm: 'R', exercise: 'teres' } });
            if (Exercises.findIndex((E) => E === 'house') > -1) DHouse = SortedBenchmarks.map((SB) => { return { y: SB.R_max_house, arm: 'R', exercise: 'surfer' } });
        }
        if (Arm.findIndex((A) => A === 'L') > -1) {
            if (Exercises.findIndex((E) => E === 'supra') > -1) NDSupra = SortedBenchmarks.map((SB) => { return { y: SB.L_max_supra, arm: 'L', exercise: 'supra' } });
            if (Exercises.findIndex((E) => E === 'subscap') > -1) NDSubscap = SortedBenchmarks.map((SB) => { return { y: SB.L_max_subscap, arm: 'L', exercise: 'subscap' } });
            if (Exercises.findIndex((E) => E === 'infra') > -1) NDInfra = SortedBenchmarks.map((SB) => { return { y: SB.L_max_infra, arm: 'L', exercise: 'infra' } });
            if (Exercises.findIndex((E) => E === 'teres') > -1) NDTeres = SortedBenchmarks.map((SB) => { return { y: SB.L_max_teres, arm: 'L', exercise: 'teres' } });
            if (Exercises.findIndex((E) => E === 'house') > -1) NDHouse = SortedBenchmarks.map((SB) => { return { y: SB.L_max_house, arm: 'L', exercise: 'surfer' } });
        }

        // For all of the mapped data, if there is a null or '0.0' value for all 5 sets in the same array position, delete that position from the SetX array and label - This will remove X Axis labels where there is no Data.
        let EmptyData = [];
        let max_y_axis = 0;
        DSupra.forEach((S, index) => {
            if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y);

            if (S.y === null || S.y === '0.0') {
                EmptyData.push(index);
            }
        });

        // Get the max weight for all of the sets, to use for the y-axis max
        NDSupra.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        DSubscap.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        NDSubscap.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        DInfra.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        NDInfra.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        DTeres.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        NDTeres.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        DHouse.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        NDHouse.forEach((S) => { if (parseFloat(S.y) > parseFloat(max_y_axis)) max_y_axis = parseFloat(S.y) });
        // Set5.forEach((S) => { if ( S > max_y_axis ) max_y_axis = S  });

        console.log({ DSupra });
        console.log({ NDSupra });
        console.log({ DSubscap });
        console.log({ NDSubscap });
        console.log({ DInfra });
        console.log({ NDInfra });
        console.log({ DTeres });
        console.log({ NDTeres });
        console.log({ DHouse });
        console.log({ NDHouse });

        console.log({ max_y_axis })
        console.log({ EmptyData });
        let RemovePositions = [];
        EmptyData.forEach((ED) => {
            // If remaining Sets also have empty data, then we will remove those index positions from Labels and Sets arrays
            // if ( (NDSupra[ED] === null || NDSupra[ED] === '0.0') && (Set3[ED] === null || Set3[ED] === '0.0') && (Set4[ED] === null || Set4[ED] === '0.0') && (Set5[ED] === null || Set5[ED] === '0.0') ) {
            console.log("ED - DHouse: ", DHouse[ED])
            if (
                (NDSupra[ED].y === null || NDSupra[ED].y === undefined || NDSupra[ED].y === '0.0') &&
                (DSubscap[ED].y === null || DSubscap[ED].y === undefined || DSubscap[ED].y === '0.0') &&
                (NDSubscap[ED].y === null || NDSubscap[ED].y === undefined || NDSubscap[ED].y === '0.0') &&
                (DInfra[ED].y === null || DInfra[ED].y === undefined || DInfra[ED].y === '0.0') &&
                (NDInfra[ED].y === null || NDInfra[ED].y === undefined || NDInfra[ED].y === '0.0') &&
                (DTeres[ED].y === null || DTeres[ED].y === undefined || DTeres[ED].y === '0.0') &&
                (NDTeres[ED].y === null || NDTeres[ED].y === undefined || NDTeres[ED].y === '0.0') &&
                (DHouse[ED].y === null || DHouse[ED].y === undefined || DHouse[ED].y === '0.0') &&
                (NDHouse[ED].y === null || NDHouse[ED].y === undefined || NDHouse[ED].y === '0.0')
            ) {
                RemovePositions.push(ED);
            }
        });
        console.log({ RemovePositions });

        let DSupraFinal = [];
        let NDSupraFinal = [];
        let DSubscapFinal = [];
        let NDSubscapFinal = [];
        let DInfraFinal = [];
        let NDInfraFinal = [];
        let DTeresFinal = [];
        let NDTeresFinal = [];
        let DHouseFinal = [];
        let NDHouseFinal = [];
        // let Set5Final = [];
        let XAxisLabelsFinal = [];
        let i;
        // Push final Sets data - unless its index is in the Removed Positions
        for (i = 0; i < XAxisLabels.length; i++) {
            let use_x_axis = false;
            if (RemovePositions.findIndex((RP) => RP == i) == -1) {
                console.log("XAxisLabels[i]: ", i, ' - ', XAxisLabels[i])
                console.log("DSupra: ", i, ' - ', DSupra[i]);
                console.log("DInfra: ", i, ' - ', DInfra[i]);
                console.log("DTeres: ", i, ' - ', DTeres[i]);

                // if ( DSupra[i] !== '0.0' ) DSupraFinal.push(DSupra[i]); use_x_axis = true;
                // if ( NDSupra[i] !== '0.0' ) NDSupraFinal.push(NDSupra[i]); use_x_axis = true;
                // if ( DSubscap[i] !== '0.0' ) DSubscapFinal.push(DSubscap[i]); use_x_axis = true;
                // if ( NDSubscap[i] !== '0.0' ) NDSubscapFinal.push(NDSubscap[i]); use_x_axis = true;
                // if ( DInfra[i] !== '0.0' ) DInfraFinal.push(DInfra[i]); use_x_axis = true;
                // if ( NDInfra[i] !== '0.0' ) NDInfraFinal.push(NDInfra[i]); use_x_axis = true;
                // if ( DTeres[i] !== '0.0' ) DTeresFinal.push(DTeres[i]); use_x_axis = true;
                // if ( NDTeres[i] !== '0.0' ) NDTeresFinal.push(NDTeres[i]); use_x_axis = true;
                // if ( DHouse[i] !== '0.0' ) DHouseFinal.push(DHouse[i]); use_x_axis = true;
                // if ( NDHouse[i] !== '0.0' ) NDHouseFinal.push(NDHouse[i]); use_x_axis = true;

                // if ( DSupra[i].y !== '0.0' ) DSupraFinal.push({x: XAxisLabels[i], y: DSupra[i]}); use_x_axis = true;
                // if ( NDSupra[i].y !== '0.0' ) NDSupraFinal.push({x: XAxisLabels[i], y: NDSupra[i]}); use_x_axis = true;
                // if ( DSubscap[i].y !== '0.0' ) DSubscapFinal.push({x: XAxisLabels[i], y: DSubscap[i]}); use_x_axis = true;
                // if ( NDSubscap[i].y !== '0.0' ) NDSubscapFinal.push({x: XAxisLabels[i], y: NDSubscap[i]}); use_x_axis = true;
                // if ( DInfra[i].y !== '0.0' ) DInfraFinal.push({x: XAxisLabels[i], y: DInfra[i]}); use_x_axis = true;
                // if ( NDInfra[i].y !== '0.0' ) NDInfraFinal.push({x: XAxisLabels[i], y: NDInfra[i]}); use_x_axis = true;
                // if ( DTeres[i].y !== '0.0' ) DTeresFinal.push({x: XAxisLabels[i], y: DTeres[i]}); use_x_axis = true;
                // if ( NDTeres[i].y !== '0.0' ) NDTeresFinal.push({x: XAxisLabels[i], y: NDTeres[i]}); use_x_axis = true;
                // if ( DHouse[i].y !== '0.0' ) DHouseFinal.push({x: XAxisLabels[i], y: DHouse[i]}); use_x_axis = true;
                // if ( NDHouse[i].y !== '0.0' ) NDHouseFinal.push({x: XAxisLabels[i], y: NDHouse[i]}); use_x_axis = true;
                if (Arm.findIndex((A) => A === 'R') > -1) {
                    if (Exercises.findIndex((E) => E === 'supra') > -1 && DSupra[i].y !== '0.0') DSupraFinal.push({ ...DSupra[i], x: XAxisLabels[i] }); use_x_axis = true;
                    if (Exercises.findIndex((E) => E === 'subscap') > -1 && DSubscap[i].y !== '0.0') DSubscapFinal.push({ ...DSubscap[i], x: XAxisLabels[i] }); use_x_axis = true;
                    if (Exercises.findIndex((E) => E === 'infra') > -1 && DInfra[i].y !== '0.0') DInfraFinal.push({ ...DInfra[i], x: XAxisLabels[i] }); use_x_axis = true;
                    if (Exercises.findIndex((E) => E === 'teres') > -1 && DTeres[i].y !== '0.0') DTeresFinal.push({ ...DTeres[i], x: XAxisLabels[i] }); use_x_axis = true;
                    if (Exercises.findIndex((E) => E === 'house') > -1 && DHouse[i].y !== '0.0') DHouseFinal.push({ ...DHouse[i], x: XAxisLabels[i] }); use_x_axis = true;
                }
                if (Arm.findIndex((A) => A === 'L') > -1) {
                    if (Exercises.findIndex((E) => E === 'supra') > -1 && NDSupra[i].y !== '0.0') NDSupraFinal.push({ ...NDSupra[i], x: XAxisLabels[i] }); use_x_axis = true;
                    if (Exercises.findIndex((E) => E === 'subscap') > -1 && NDSubscap[i].y !== '0.0') NDSubscapFinal.push({ ...NDSubscap[i], x: XAxisLabels[i] }); use_x_axis = true;
                    if (Exercises.findIndex((E) => E === 'infra') > -1 && NDInfra[i].y !== '0.0') NDInfraFinal.push({ ...NDInfra[i], x: XAxisLabels[i] }); use_x_axis = true;
                    if (Exercises.findIndex((E) => E === 'teres') > -1 && NDTeres[i].y !== '0.0') NDTeresFinal.push({ ...NDTeres[i], x: XAxisLabels[i] }); use_x_axis = true;
                    if (Exercises.findIndex((E) => E === 'house') > -1 && NDHouse[i].y !== '0.0') NDHouseFinal.push({ ...NDHouse[i], x: XAxisLabels[i] }); use_x_axis = true;
                }


                // Above based on instead filtering each dataset by its arm/exercise: data.filter(o => o.type == 'expense').map(o => ({ x: o.date, y: o.amount }))

                // DSupraFinal.push(DSupra[i]);
                // NDSupraFinal.push(NDSupra[i]);
                // DSubscapFinal.push(DSubscap[i]);
                // NDSubscapFinal.push(NDSubscap[i]);
                // DInfraFinal.push(DInfra[i]);
                // NDInfraFinal.push(NDInfra[i]);
                // DTeresFinal.push(DTeres[i]);
                // NDTeresFinal.push(NDTeres[i]);
                // DHouseFinal.push(DHouse[i]);
                // NDHouseFinal.push(NDHouse[i]);
                // Set5Final.push(Set5[i]);

                // Only add this X Axis label if we pushed a value above
                if (use_x_axis === true) XAxisLabelsFinal.push(XAxisLabels[i]);
            }
        }
        console.log({ XAxisLabelsFinal })
        console.log({ DSupraFinal });
        console.log({ NDSupraFinal });
        console.log({ DSubscapFinal });
        console.log({ NDSubscapFinal });
        console.log({ DInfraFinal });
        console.log({ NDInfraFinal });
        console.log({ DTeresFinal });
        console.log({ NDTeresFinal });
        console.log({ DHouseFinal });
        console.log({ NDHouseFinal });
        // console.log({Set5Final});
        let BaseDataSet = { borderColor: 'black', borderWidth: 2 };

        // Blues
        // let bg1_d = '#ADC8E6';
        // let bg2_d = '#87CEFA';
        // let bg5_d = '#B3CEE5';
        // let bg3_d = '#C8DCE6';
        // let bg4_d = '#96B4C8';
        let bg1_d = 'Blue';
        let bg2_d = 'Orange';
        let bg5_d = 'Purple';
        let bg3_d = 'Red';
        let bg4_d = 'Green';
        // Greys
        // let bg1_nd = '#5A5A5A';
        // let bg2_nd = '#818589';
        // let bg3_nd = '#808080';
        // let bg4_nd = '#899499';
        // let bg5_nd = '#D3D3D3';
        let bg1_nd = 'LightBlue';
        let bg2_nd = 'Yellow';
        let bg5_nd = 'Grey';
        let bg3_nd = 'Pink';
        let bg4_nd = 'LightGreen';

        function createDiagonalPattern(color = 'black') {
            // create a 10x10 px canvas for the pattern's base shape
            let shape = document.createElement('canvas')
            shape.width = 10
            shape.height = 10
            // get the context for drawing
            let c = shape.getContext('2d')
            // draw 1st line of the shape 
            c.strokeStyle = color
            c.beginPath()
            c.moveTo(2, 0)
            c.lineTo(10, 8)
            c.stroke()
            // draw 2nd line of the shape 
            c.beginPath()
            c.moveTo(0, 8)
            c.lineTo(2, 10)
            c.stroke()
            // create the pattern from the shape
            return c.createPattern(shape, 'repeat')
        }

        // Lastly, check if any of the Sets have only null or '0.0', we can condense the datasets if so.
        let TempDatasets = [];
        // These might be able to add detail to the points:
        // pointBorderColor: '#B2BABB',
        // pointBackgroundColor: '#D4AC0D',
        // pointHoverBackgroundColor: '#D4AC0D',
        // pointHoverBorderColor: 'black',

        // lineTension: 0.1,
        // borderCapStyle: 'butt',
        // borderDash: [],
        // borderDashOffset: 0.0,
        // borderJoinStyle: 'miter',

        // pointBorderWidth: 1,
        // pointHoverRadius: 5,
        // pointHoverBorderWidth: 2,
        // pointRadius: 3,
        // pointHitRadius: 10,
        if (DSupraFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: DSupraFinal, label: 'Supra - Dom', borderColor: bg1_d, backgroundColor: bg1_d, borderWidth: 5, datalabels: { align: 'start', anchor: 'start' } });
        if (NDSupraFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: NDSupraFinal, label: 'Supra - Non-Dom', borderColor: bg1_d, backgroundColor: bg1_d, borderDash: [15, 5], borderWidth: 5, datalabels: { align: 'start', anchor: 'start' } });
        if (DInfraFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: DInfraFinal, label: 'Infra - Dom', borderColor: bg3_d, backgroundColor: bg3_d, borderWidth: 5, datalabels: { align: 'start', anchor: 'start' } });
        if (NDInfraFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: NDInfraFinal, label: 'Infra - Non-Dom', borderColor: bg3_d, backgroundColor: bg3_d, borderDash: [15, 5], borderWidth: 5, datalabels: { align: 'start', anchor: 'start' } });
        if (DTeresFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: DTeresFinal, label: 'Teres Minor - Dom', borderColor: bg4_d, backgroundColor: bg4_d, borderWidth: 5, datalabels: { align: 'start', anchor: 'start' } });
        if (NDTeresFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: NDTeresFinal, label: 'Teres Minor - Non-Dom', borderColor: bg4_d, backgroundColor: bg4_d, borderDash: [15, 5], borderWidth: 5, datalabels: { align: 'start', anchor: 'start' } });
        if (DSubscapFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: DSubscapFinal, label: 'Subscap - Dom', borderColor: bg2_d, backgroundColor: bg2_d, borderWidth: 5, datalabels: { align: 'end', anchor: 'end' } });
        if (NDSubscapFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: NDSubscapFinal, label: 'Subscap - Non-Dom', borderColor: bg2_d, backgroundColor: bg2_d, borderDash: [15, 5], borderWidth: 5, datalabels: { align: 'end', anchor: 'end' } });
        if (DHouseFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: DHouseFinal, label: 'House Combo - Dom', borderColor: bg5_d, backgroundColor: bg5_d, borderWidth: 5, datalabels: { align: 'start', anchor: 'start' } });
        if (NDHouseFinal.findIndex((S) => S.y !== null && S.y !== '0.0' && S.y !== undefined) > -1) TempDatasets.push({ ...BaseDataSet, data: NDHouseFinal, label: 'House Combo - Non-Dom', borderColor: bg5_d, backgroundColor: bg5_d, borderDash: [15, 5], borderWidth: 5, datalabels: { align: 'start', anchor: 'start' } });
        // if ( Set5Final.findIndex((S) => S !== null && S !== '0.0') > -1 ) TempDatasets.push({...BaseDataSet, data: Set5Final, label: 'Set 5', backgroundColor: bg5 });
        console.log({ TempDatasets });

        // Any '0.0' values in the Datasets need to be set to null so they are not graphed
        let CleanDatasets = TempDatasets.map((DS) => {

            let CleanData = DS.data.map((D) => {
                return D === '0.0' ? '' : D;
            });

            return { ...DS, data: CleanData };
        })
        console.log({ CleanDatasets });

        setGraphData({
            ...GraphData,
            labels: XAxisLabelsFinal,
            datasets: CleanDatasets
        });

        // Create graph title
        let temp_arm = 'Dominant & Non-Dominant';
        console.log({ Arm })
        if (Arm.length === 1) {
            if (Arm.findIndex((A) => A === 'L') > -1) temp_arm = 'Non-Dominant';
            else if (Arm.findIndex((A) => A === 'R') > -1) temp_arm = 'Dominant';
        }

        let temp_ex = Exercises.length === 5 ? ['All Exercises'] : [];
        if (Exercises.length !== 5) {
            if (Exercises.findIndex((E) => E === 'supra') > -1) temp_ex.push('Supra');
            if (Exercises.findIndex((E) => E === 'infra') > -1) temp_ex.push('Infra');
            if (Exercises.findIndex((E) => E === 'teres') > -1) temp_ex.push('Teres Minor');
            if (Exercises.findIndex((E) => E === 'subscap') > -1) temp_ex.push('Subscap');
            if (Exercises.findIndex((E) => E === 'house') > -1) temp_ex.push('House Combo');
        }
        console.log({ temp_ex })
        let graph_title = `${temp_ex.join(', ')} - ${temp_arm}`;
        if (Arm.length === 0) graph_title = 'PLEASE SELECT DOMINANT OR NON-DOMINANT SIDE TO GENERATE GRAPH';
        else if (Exercises.length === 0) graph_title = 'PLEASE SELECT EXERCISE(S) TO GENERATE GRAPH';
        setGraphOptions({
            ...GraphOptions,
            plugins: {
                ...GraphOptions.plugins,
                title: {
                    ...GraphOptions.plugins.title,
                    text: graph_title
                },
                tooltip: {
                    enabled: true,
                    // mode: "index",
                    intersect: false,
                    backgroundColor: 'grey',
                    borderColor: function (context) {
                        // console.log("BORDER COLOR CONTEXT: ", context)
                        if (context.tooltipItems.length > 0) {
                            return context.tooltipItems[0].dataset.borderColor
                        } else {
                            return 'black';
                        }
                    },
                    callbacks: { //Added callbacks for label
                        // title: () => {
                        //     return "title here";
                        // },
                        // labelColor: function(context) {
                        //     console.log("LABEL COLOR CONTEXT: ", context)
                        //     return {
                        //         borderColor: 'red'
                        //     }
                        // },
                        title: (context) => {
                            console.log("title context: ", context)
                            // context is an array of tooltip items
                            //return context[0].dataset.label; // Displays the dataset label as the title
                            return `${context[0].dataset.label}     ${context[0].raw.x}`; // Displays the dataset label as the title
                        },
                        label: (context) => {
                            // context is the tooltip item
                            console.log("CONTEXT LABEL: ", context)
                            // let Lines = [`  Benchmark: ${context.formattedValue} lbs`];
                            let Lines = [`  Benchmark:`];
                            Lines.push(`  ${context.formattedValue} lbs`)

                            let this_index = context.dataset.data.findIndex((data) => data.x == context.label);

                            // If this is not the first data point, show the previous benchmark's dataset and workouts in between this and the last benchmark
                            if (this_index !== 0) {
                                let last_benchmark = context.dataset.data[this_index - 1].y;
                                let this_benchmark = context.dataset.data[this_index].y;
                                // Lines.push(`  Previous:     ${last_benchmark} lbs`);
                                Lines.push(`  Previous:`);
                                Lines.push(`  ${last_benchmark} lbs`);

                                // Calculate the % increase / descrease from the previous benchmark
                                let difference_benchmark = multiply(divide(subtract(this_benchmark, last_benchmark), this_benchmark), 100);
                                if (difference_benchmark > 0 || difference_benchmark < 0) {
                                    let change_diff = difference_benchmark > 0 ? 'Increased' : 'Decreased';
                                    // Lines.push(`  ${change_diff}:    ${difference_benchmark.toFixed(1)}%`);
                                    Lines.push(`  ${change_diff}:`);
                                    Lines.push(`  ${difference_benchmark.toFixed(1)}%`);
                                } else {
                                    Lines.push('  No Change');
                                }

                                // Calculate the % increase / descrease from the first benchmark
                                if (this_index !== 1) {
                                    let first_benchmark = context.dataset.data[0].y;
                                    let difference_benchmark_first = multiply(divide(subtract(this_benchmark, first_benchmark), this_benchmark), 100);
                                    if (difference_benchmark_first > 0 || difference_benchmark_first < 0) {
                                        let change_diff = difference_benchmark_first > 0 ? 'Increased' : 'Decreased';
                                        // Lines.push(`  ${change_diff} Since 1st Benchmark:    ${difference_benchmark_first.toFixed(1)}%`);
                                        Lines.push(`  ${change_diff} Since 1st Benchmark:`);
                                        Lines.push(`  ${difference_benchmark_first.toFixed(1)}%`);
                                    }
                                }

                                // Filter the Workouts since the last Benchmark.
                                let PrevWorkouts = Workouts.filter((W) => dayjs(W.exercise_date).isBefore(context.dataset.data[this_index].x) && dayjs(W.exercise_date).isAfter(context.dataset.data[this_index - 1].x));
                                let torque_total = 0;
                                PrevWorkouts.forEach((W) => torque_total = add(torque_total, W[`${context.raw.arm}_torque_${context.raw.exercise}`]));
                                Lines.push('');
                                Lines.push('Work done since previous benchmark');
                                Lines.push(`   ${torque_total.toFixed(0)} ft-lbs from ${dayjs(context.dataset.data[this_index - 1].x).format('MM-DD-YY')} to ${dayjs(context.dataset.data[this_index].x).format('MM-DD-YY')}`);
                                Lines.push('');
                                Lines.push(`${PrevWorkouts.length} Workouts Completed`)
                                PrevWorkouts.forEach((W) => {
                                    let torque = parseFloat(W[`${context.raw.arm}_torque_${context.raw.exercise}`]);
                                    Lines.push(`   ${torque.toFixed(0)} ft-lbs on ${dayjs(W.exercise_date).format('MM-DD-YY')}`);
                                });


                                // NEXT - REPLACE THE ABOVE LINES WITH THE ACTUAL TORQUES FOR THE SIDE AND EXERCISE THAT MATCH THE DATA 
                            }
                            //context.raw.Sets.forEach((Set, index)=> Lines.push( `Set ${index+1}:    ${Set.reps} Rep${(Set.reps > 1 && 's') || ''}  -  ${Set.weight} lbs` ) );

                            return Lines;
                        },
                        // footer: (context) => {
                        //     // context is an array of tooltip items
                        //     let sum = 0;
                        //     context.forEach((item) => {
                        //         sum += item.parsed.y;
                        //     });
                        //     return `Sum: ${sum}`; // Displays the sum of values in the tooltip
                        // },                    
                    }
                },
            },
            scales: {
                y: {
                    beginAtZero: true,
                    max: add(max_y_axis, 1),
                    min: 0,
                    ticks: {
                        stepSize: max_y_axis < 10 ? 1 : 2
                    },
                    title: {
                        display: true,
                        text: 'Weight (Lbs)'
                    }
                },
                // x : [
                //     {

                //     }
                // ]
            }
        });

        // scales: {
        //     y: {
        //     },
        // }

        setGraphGenerated(true);
        setTimeout(() => targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' }), GraphGenerated ? 0 : 300);
    }

    // Click handler for selecting exercises to graph. If the exercise is already in the array, remove it, otherwise add it.
    function handleSetExercises(exercise) {
        let index = Exercises.findIndex((E) => E === exercise);
        let TempExercises = [...Exercises];

        if (exercise === 'all') {
            TempExercises = ['supra', 'subscap', 'infra', 'teres', 'house'];
        } else if (exercise === 'clear') {
            TempExercises = [];
        } else if (index > -1) {
            TempExercises.splice(index, 1);
        } else {
            TempExercises.push(exercise);
        }
        setExercises(TempExercises);
        targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
    };

    // Click handler for selecting arm sides to graph. If the side is already in the array, remove it, otherwise add it.
    function handleSetArm(arm) {
        let index = Arm.findIndex((A) => A === arm);
        let TempArm = [...Arm];
        if (index > -1) {
            TempArm.splice(index, 1);
        } else {
            TempArm.push(arm);
        }
        setArm(TempArm);
        targetRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
    };

    function Printing(printing_props) {
        const componentRef = useRef();
        const handlePrint = useReactToPrint({
            content: () => componentRef.current
        });
        //marginTop: 150+'px', marginLeft: 50+'px', 
        return (
            <>
                <div className="card-body"
                    style={{
                        width: subtract(window.innerWidth, 100) + 'px',
                        height: subtract(window.innerHeight, 120) + 'px',
                        display: 'flex', justifyContent: 'center'
                    }}
                >
                    <Printer graph_type={"line"} ref={componentRef} options={GraphOptions} data={GraphData} />
                </div>
                <div className="text-center mb-1">
                    <button className={printing_props.class} onClick={handlePrint}><FontAwesomeIcon icon="fa-print" size="xl" className="me-2" />{printing_props.button}</button>
                </div>
            </>
        );
    };

    console.log({ GraphData })

    return (
        <div className="card mb-4">
            {
                GraphGenerated &&
                <Printing class={'btn btn-sm border-primary text-primary fw-bold border-3'} button={"Print Graph"} />
            }
            {
                !GraphGenerated &&
                <div className="card-body">
                    <div className="row justify-content-center">
                        <div className="col-auto">
                            <div className="alert alert-info mb-0">Select Exercise(s) and Side(s) below, then click to Generate Graph.</div>
                        </div>
                    </div>
                </div>
            }
            {/* <div className="card-footer border border-secondary" ref={targetRef}>
                <div className="row clearfix my-1 justify-content-center">

                    <div className="col-auto">
                        <div className="btn-group btn-group-sm" role="group">
                            <button className={`btn btn-outline-secondary text-dark}`} onClick={() => handleSetExercises('all')}>
                                All
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'supra') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('supra')}>
                                Supra
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'infra') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('infra')}>
                                Infra
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'teres') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('teres')}>
                                Teres Minor
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'subscap') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('subscap')}>
                                Subscap
                            </button>
                            <button className={`btn btn-outline-secondary ${(Exercises.findIndex((E) => E === 'house') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetExercises('house')}>
                                House Combo
                            </button>
                            <button className={`btn btn-outline-secondary text-dark}`} onClick={() => handleSetExercises('clear')}>
                                Clear
                            </button>
                        </div>                            
                    </div>

                    <div className="col-auto">
                        <div className="btn-group btn-group-sm" role="group">
                            <button className={`btn btn-outline-secondary ${(Arm.findIndex((A) => A === 'L') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetArm('L')}>
                                Non-Dom
                            </button>
                            <button className={`btn btn-outline-secondary ${(Arm.findIndex((A) => A === 'R') > -1 && 'btn-secondary text-white border border-dark') || 'text-dark'}`} onClick={() => handleSetArm('R')}>
                                Dom
                            </button>
                        </div>                            
                    </div>

                </div>
            </div> */}
        </div>

    )
}


